@let selectedUserParametersValue = selectedUserParameters();
@let selectedParameterSetValue = selectedParameterSet();
@let isMobilePlatformValue = isMobilePlatform();
@let greenTableDesignValue = eppService.greenTableDesign();
@let colorMappingPerParametersetValue =
  eppService.colorMappingPerParameterset();
@let colorMappingsValue = eppService.colorMappings();
<mat-drawer-container autosize>
  <!-- Settings -->
  <mat-drawer #drawer mode="over" position="end">
    <button mat-icon-button class="close-button" (click)="drawer.toggle()">
      <fa-icon [icon]="['far', 'times']"></fa-icon>
    </button>
    <ng-container *ngTemplateOutlet="erpSettings"></ng-container>
  </mat-drawer>

  <div
    class="base-container"
    [class.is-mobile-platform]="isMobilePlatformValue">
    <a id="start"></a>
    <form>
      @if (!isMobilePlatformValue) {
        <div class="settings-button-stack">
          <button
            mat-mini-fab
            class="settings-button"
            (click)="onSetupSettings(); drawer.toggle()"
            [matTooltip]="'HOME.SETTINGS' | translate">
            <fa-icon [icon]="['far', 'cogs']" size="lg"></fa-icon>
          </button>
          <button
            mat-mini-fab
            class="settings-button"
            tp="{{ 'PRODUCT.ERP.INFO' | translate }}"
            variation="popper"
            trigger="mouseenter"
            tpPlacement="left">
            <fa-icon [icon]="['far', 'info-circle']" size="lg"></fa-icon>
          </button>
          <button
            mat-mini-fab
            class="settings-button palette-toggle-button"
            [class.palette-toggle-button--active]="neutralColor() === 'green'"
            (click)="onToggleColor(neutralColor() !== 'green')"
            [matTooltip]="
              (neutralColor() === 'green'
                ? 'PRODUCT.EPP.SETTINGS.COLOR.GREEN'
                : 'PRODUCT.EPP.SETTINGS.COLOR.WHITE'
              ) | translate
            "
            tpPlacement="left">
            <fa-icon [icon]="['far', 'palette']" size="lg"></fa-icon>
          </button>
        </div>
      }
      <!-- Panel -->
      <div class="panel">
        @let parameterSetsValue = parameterSets();
        @if (parameterSetsValue.length > 1) {
          <!-- Parameterset Select -->
          <mat-form-field appearance="fill" class="parameterset-select">
            <mat-label>{{
              'PRODUCT.EPP.PARAMETERSET.SELECT' | translate
            }}</mat-label>
            <mat-select
              [formControl]="parametersetSelectControl"
              placeholder="{{ 'PRODUCT.EPP.PARAMETERSET.SELECT' | translate }}">
              @for (parameterSet of parameterSetsValue; track $index) {
                <mat-option
                  [value]="parameterSet"
                  (onSelectionChange)="onParameterSetChange($event)">
                  {{
                    'PRODUCT.EPP.PARAMETERSET.SETS.' + parameterSet | translate
                  }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
      </div>
    </form>
    <div class="erp-forecast-view-container">
      <mat-tab-group
        [selectedIndex]="tabsSelectedIndex()"
        (selectedTabChange)="onTabChanged($event)"
        class="erp-main-tab-group custom-dashboard-tabs">
        <!-- TABS 1: STÜNDLICHE RASTER-AUSWERTUNG -->
        <mat-tab>
          <ng-template mat-tab-label>
            <fa-icon [icon]="['far', 'clock']" class="tab-label-icon"></fa-icon>
            {{ 'PRODUCT.ERP.TYPE.HOURLY' | translate }}
          </ng-template>

          <ng-template matTabContent>
            <mat-card appearance="outlined" class="erp-table-glass-card">
              <div class="erp-table-scroll-wrapper">
                @let selectedUserParametersValue = selectedUserParameters();
                @if (
                  (
                    selectedUserParametersValue?.[selectedParameterSetValue] ??
                    []
                  ).length > 0
                ) {
                  <table
                    class="table"
                    [class.is-mobile-platform]="isMobilePlatformValue">
                    <thead>
                      <tr class="table-header-row-title is-sticky-top">
                        @if (!isMobilePlatformValue) {
                          <th
                            class="th-region-sticky cell-align-left"
                            rowspan="2">
                            {{ 'PRODUCT.ERP.REGION' | translate }}
                          </th>
                        }
                        <th
                          class="th-parameter-sticky cell-align-left"
                          [class.is-mobile-platform]="isMobilePlatformValue"
                          rowspan="2"
                          [attr.colspan]="isMobilePlatformValue ? 1 : 2">
                          @if (!isMobilePlatformValue) {
                            {{ 'PRODUCT.ERP.PARAMETERS' | translate }}
                          }
                        </th>
                        <th
                          class="th-time-resolution-header cell-align-center"
                          colspan="24">
                          {{ 'PRODUCT.ERP.FORECAST' | translate }}
                        </th>
                      </tr>
                      <tr class="table-header-row-units is-sticky-sub-top">
                        @for (hour of hours(); track $index) {
                          <th
                            class="cell-time-tick"
                            (mouseenter)="hoveredColumnIndex = $index"
                            (mouseleave)="hoveredColumnIndex = null"
                            [class.column-hovered]="
                              hoveredColumnIndex === $index
                            ">
                            {{ hour }}
                          </th>
                        }
                      </tr>
                    </thead>

                    @for (region of regions(); track $index; let i = $index) {
                      @if (
                        region.name
                          | checkRegionForParameterset
                            : solarpowerMode()
                            : windpowerMode()
                      ) {
                        <tr>
                          <td style="height: 20px">&nbsp;</td>
                          <td colspan="24" class="region-spacer"></td>
                        </tr>
                        <tbody class="region-data-body-verbund">
                          <ng-container
                            [ngTemplateOutlet]="singleRegion"
                            [ngTemplateOutletContext]="{
                              templateRegion: region,
                              templateRegionIndex: i,
                            }">
                          </ng-container>
                        </tbody>

                        <tbody
                          class="station-expanded-body-verbund"
                          [@showStations]="
                            region.expanded ? 'expanded' : 'collapsed'
                          ">
                          <ng-container
                            [ngTemplateOutlet]="singleStationOfRegion"
                            [ngTemplateOutletContext]="{
                              templateRegion: region,
                            }">
                          </ng-container>
                        </tbody>
                      }
                    }
                  </table>
                }
              </div>
            </mat-card>
          </ng-template>
        </mat-tab>

        <!-- TABS 2: 8-TAGE LANGZEIT-TREND -->
        <mat-tab>
          <ng-template mat-tab-label>
            <fa-icon
              [icon]="['far', 'calendar-alt']"
              class="tab-label-icon"></fa-icon>
            {{ 'PRODUCT.ERP.TYPE.EIGHT_DAY_ALL' | translate }}
          </ng-template>

          <ng-template matTabContent>
            <mat-card appearance="outlined" class="erp-table-glass-card">
              <div class="erp-table-scroll-wrapper">
                @if (
                  (
                    selectedUserParametersValue?.[selectedParameterSetValue] ??
                    []
                  ).length > 0
                ) {
                  <table
                    class="table table-layout--eight-day"
                    [class.is-mobile-platform]="isMobilePlatformValue">
                    <thead>
                      <tr class="table-header-row-title is-sticky-top">
                        @if (!isMobilePlatformValue) {
                          <th
                            class="th-region-sticky cell-align-left"
                            rowspan="3">
                            {{ 'PRODUCT.ERP.REGION' | translate }}
                          </th>
                        }
                        <th
                          class="th-parameter-sticky cell-align-left"
                          [class.is-mobile-platform]="isMobilePlatformValue"
                          rowspan="3"
                          [attr.colspan]="isMobilePlatformValue ? 1 : 2">
                          @if (!isMobilePlatformValue) {
                            {{ 'PRODUCT.ERP.PARAMETERS' | translate }}
                          }
                        </th>
                        <th
                          class="th-time-resolution-header cell-align-center"
                          colspan="16">
                          {{ 'PRODUCT.ERP.FORECAST' | translate }}
                        </th>
                      </tr>
                      <tr class="table-header-row-units is-sticky-sub-top">
                        @for (day of days; track $index) {
                          <th colspan="2" class="cell-day-group-header">
                            {{ day | datex: 'dd D.M.' }}
                          </th>
                        }
                      </tr>
                      <tr
                        class="table-header-row-units-sub is-sticky-third-top">
                        @for (day of days; track $index) {
                          <th class="cell-diurnal-icon diurnal--night">
                            <fa-icon [icon]="['fal', 'moon']"></fa-icon>
                          </th>
                          <th class="cell-diurnal-icon diurnal--day">
                            <fa-icon [icon]="['fal', 'sun']"></fa-icon>
                          </th>
                        }
                      </tr>
                    </thead>

                    @for (region of regions(); track $index; let i = $index) {
                      @if (
                        region.name
                          | checkRegionForParameterset
                            : solarpowerMode()
                            : windpowerMode()
                      ) {
                        <tr>
                          <td style="height: 20px">&nbsp;</td>
                          <td colspan="24" class="region-spacer"></td>
                        </tr>
                        <tbody class="region-data-body-verbund">
                          <ng-container
                            [ngTemplateOutlet]="singleRegion"
                            [ngTemplateOutletContext]="{
                              templateRegion: region,
                              templateRegionIndex: i,
                            }">
                          </ng-container>
                        </tbody>

                        <tbody
                          class="station-expanded-body-verbund"
                          [@showStations]="
                            region.expanded ? 'expanded' : 'collapsed'
                          ">
                          <ng-container
                            [ngTemplateOutlet]="singleStationOfRegion"
                            [ngTemplateOutletContext]="{
                              templateRegion: region,
                            }">
                          </ng-container>
                        </tbody>
                      }
                    }
                  </table>
                } @else {
                  <div class="erp-no-data-fallback-container">
                    <div class="fallback-icon-avatar">
                      <fa-icon
                        [icon]="['fal', 'cloud-meatball']"
                        size="3x"
                        class="meatball-icon-glow"></fa-icon>
                    </div>
                    <p class="fallback-instruction-text">
                      Keine Vorhersage-Parameter ausgewählt. Bitte konfigurieren
                      Sie Ihre Grid-Einstellungen.
                    </p>
                    <button
                      mat-flat-button
                      class="btn-app-save erp-fallback-setup-btn"
                      (click)="onSetupSettings(); drawer.toggle()">
                      <fa-icon [icon]="['far', 'cogs']"></fa-icon>
                      &nbsp; {{ 'HOME.SETTINGS' | translate }}
                    </button>
                  </div>
                }
              </div>
            </mat-card>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</mat-drawer-container>

<!--
============================================= TEMPLATES =============================================
-->
<!-- single Region  -->
<ng-template
  #singleRegion
  let-region="templateRegion"
  let-i="templateRegionIndex">
  <tr class="erp-table__tr--divider"></tr>
  @if (!isMobilePlatformValue) {
    <tr class="erp-table__tr--hide">
      <td
        class="region-cell"
        role="button"
        tabindex="0"
        [class.is-open]="region.expanded"
        [class.is-clickable]="region.stations?.length > 0"
        (click)="onChangeRegionExpand(i)"
        (keydown.enter)="onChangeRegionExpand(i)"
        (keydown.space)="onChangeRegionExpand(i); $event.preventDefault()"
        [matTooltip]="
          region.expanded
            ? ('components.erp.unclick_stations' | translate)
            : ('components.erp.click_stations' | translate)
        "
        colspan="1"
        [attr.rowspan]="
          selectedUserParametersValue[selectedParameterSetValue].length + 1
        ">
        <div class="region-content">
          <span class="region-chevron">
            <fa-icon
              [icon]="[
                'far',
                region.expanded ? 'chevron-down' : 'chevron-right',
              ]">
            </fa-icon>
          </span>

          <span class="region-text-block">
            <span class="region-name">{{ region.name }}</span>
            <span class="region-click-hint">
              {{
                region.expanded
                  ? ('components.erp.details_open' | translate)
                  : ('components.erp.click_stations' | translate)
              }}
            </span>
          </span>

          <span class="region-station-count">
            {{ region.stations?.length ?? 0 }}
          </span>
        </div>
      </td>
    </tr>
  } @else {
    <!-- Mobile: region name as its own full-width row instead of a column,
         so the parameter/forecast columns get the width back. -->
    <tr
      class="region-row-mobile"
      role="button"
      tabindex="0"
      [class.is-open]="region.expanded"
      (click)="onChangeRegionExpand(i)"
      (keydown.enter)="onChangeRegionExpand(i)"
      (keydown.space)="onChangeRegionExpand(i); $event.preventDefault()">
      <td class="region-cell-mobile" [attr.colspan]="mobileRegionRowColspan()">
        <div class="region-cell-mobile-inner">
          <span class="region-chevron">
            <fa-icon
              [icon]="[
                'far',
                region.expanded ? 'chevron-down' : 'chevron-right',
              ]">
            </fa-icon>
          </span>
          <span class="region-name">{{ region.name }}</span>
          <span class="region-station-count">
            {{ region.stations?.length ?? 0 }}
          </span>
        </div>
      </td>
    </tr>
  }

  @for (
    parameter of selectedUserParametersValue[selectedParameterSetValue];
    track $index;
    let i = $index
  ) {
    <ng-container
      [ngTemplateOutlet]="singleParameter"
      [ngTemplateOutletContext]="{
        templateParameter: parameter,
        templateIndex: i,
        templateRegion: region.id,
        templateStation: null,
      }">
    </ng-container>
  }
</ng-template>
<!-- single Station -->
<ng-template #singleStationOfRegion let-region="templateRegion">
  <tr class="erp-table__tr--divider station-divider-row">
    <td class="erp-table__region-group"></td>
  </tr>
  @for (station of region.stations; track $index) {
    @if (!isMobilePlatformValue) {
      <tr class="station-row">
        <td
          class="erp-table__station-name erp-table__region-group"
          [attr.rowspan]="
            selectedUserParametersValue[selectedParameterSetValue].length + 2
          ">
          <div class="station-cell-content">
            <div class="station-name-line">
              <fa-icon [icon]="['far', 'map-marker-alt']"></fa-icon>
              <i>{{ station | statioName: stations() }}</i>
            </div>

            <button
              mat-button
              class="station-epp-link"
              [routerLink]="['/epp', station]">
              <fa-icon [icon]="['fal', 'clouds-sun']"></fa-icon>
              {{ 'PRODUCT.SMW.POPUP_EOP' | translate }}
            </button>
          </div>
        </td>
      </tr>
    } @else {
      <!-- Mobile: station name as its own full-width row instead of a
           column, same reasoning as the region row above. -->
      <tr class="station-row station-row-mobile">
        <td
          class="station-cell-mobile"
          [attr.colspan]="mobileRegionRowColspan()">
          <div class="station-cell-mobile-inner">
            <fa-icon [icon]="['far', 'map-marker-alt']"></fa-icon>
            <i>{{ station | statioName: stations() }}</i>
            <button
              mat-button
              class="station-epp-link"
              [routerLink]="['/epp', station]">
              <fa-icon [icon]="['fal', 'clouds-sun']"></fa-icon>
            </button>
          </div>
        </td>
      </tr>
    }

    @for (
      parameter of selectedUserParametersValue[selectedParameterSetValue];
      track $index;
      let i = $index
    ) {
      <ng-container
        [ngTemplateOutlet]="singleParameter"
        [ngTemplateOutletContext]="{
          templateParameter: parameter,
          templateIndex: i,
          templateRegion: region.id,
          templateStation: station,
        }">
      </ng-container>
    }

    <tr>
      <td colspan="24" class="region-spacer"></td>
    </tr>
  }
</ng-template>
<!-- single Parameter-->
<ng-template
  #singleParameter
  let-parameter="templateParameter"
  let-i="templateIndex"
  let-region="templateRegion"
  let-station="templateStation">
  <tr class="erp-table__tr-parameter">
    <td
      class="erp-table__icon"
      [ngClass]="{ 'erp-table__icon--mobile': isMobilePlatformValue }"
      [tp]="paramLegend"
      [tpData]="parameter"
      variation="popper"
      trigger="mouseenter"
      tpPlacement="bottom"
      [tpIsLazy]="true">
      <ng-container appWmIcon [inputParameter]="parameter"></ng-container>
    </td>

    @if (!isMobilePlatformValue) {
      <td
        class="erp-table__parameter-name"
        [tp]="paramLegend"
        [tpData]="parameter"
        variation="popper"
        trigger="mouseenter"
        tpPlacement="bottom"
        [tpIsLazy]="true">
        <span class="parameter-name-text">
          {{ 'METPARA_EPP.' + parameter | translate }}
        </span>

        @if (parameter.indexOf('power') > 0) {
          <span class="parameter-unit">[MWh]</span>
        }
      </td>
    }

    @let erpDataValue = erpData();
    @if (erpDataValue.hasOwnProperty(region) && (station | isNil)) {
      @for (
        dataset of erpDataValue[region]['aggregated_forecasts'];
        track $index
      ) {
        <ng-container
          [ngTemplateOutlet]="dataCell"
          [ngTemplateOutletContext]="{
            templateDataset: dataset,
            templateParameter: parameter,
            templateColIndex: $index,
          }">
        </ng-container>
      }
    }

    @if (erpDataValue.hasOwnProperty(region) && (station | isNil: false)) {
      @for (
        dataset of erpDataValue[region]['forecasts'][station + ''];
        track $index
      ) {
        <ng-container
          [ngTemplateOutlet]="dataCell"
          [ngTemplateOutletContext]="{
            templateDataset: dataset,
            templateParameter: parameter,
            templateColIndex: $index,
          }"></ng-container>
      }
    }
  </tr>
</ng-template>

<ng-template
  #dataCell
  let-element="templateDataset"
  let-parameter="templateParameter"
  let-colIndex="templateColIndex">
  @switch (parameter) {
    @case ((parameter | parameterClass) === 'tt_color' ? parameter : '') {
      <td
        class="erp-data-cell"
        [ngClass]="
          colIndex % 2 != 0 && element.hasOwnProperty('tx')
            ? 'cell-vert-line'
            : ''
        "
        (mouseenter)="hoveredColumnIndex = colIndex"
        (mouseleave)="hoveredColumnIndex = null"
        (click)="selectedColumnIndex = colIndex"
        [class.column-hovered]="hoveredColumnIndex === colIndex"
        [class.column-selected]="selectedColumnIndex === colIndex"
        [ngStyle]="
          selectedParameterSetValue
            | colorMapping
              : parameter
              : element[parameter]
              : greenTableDesignValue
              : colorMappingPerParametersetValue
              : colorMappingsValue
        ">
        {{
          element.hasOwnProperty(parameter)
            ? (element[parameter] | number: '1.1-1')
            : '--'
        }}
      </td>
    }

    @case (parameter === 'td' || parameter === 'sn' ? parameter : '') {
      <td
        class="erp-data-cell"
        [ngClass]="
          colIndex % 2 != 0 && element.hasOwnProperty('tx')
            ? 'cell-vert-line'
            : ''
        "
        (mouseenter)="hoveredColumnIndex = colIndex"
        (mouseleave)="hoveredColumnIndex = null"
        (click)="selectedColumnIndex = colIndex"
        [class.column-hovered]="hoveredColumnIndex === colIndex"
        [class.column-selected]="selectedColumnIndex === colIndex"
        [ngStyle]="
          selectedParameterSetValue
            | colorMapping
              : parameter
              : element[parameter]
              : greenTableDesignValue
              : colorMappingPerParametersetValue
              : colorMappingsValue
        ">
        {{
          element.hasOwnProperty(parameter)
            ? (element[parameter] | number: '1.1-1')
            : '--'
        }}
      </td>
    }

    @case ((parameter | parameterClass) === 'condition' ? parameter : '') {
      <td
        class="erp-data-cell"
        [ngClass]="
          colIndex % 2 != 0 && element.hasOwnProperty('tx')
            ? 'cell-vert-line'
            : ''
        "
        (mouseenter)="hoveredColumnIndex = colIndex"
        (mouseleave)="hoveredColumnIndex = null"
        (click)="selectedColumnIndex = colIndex"
        [class.column-hovered]="hoveredColumnIndex === colIndex"
        [class.column-selected]="selectedColumnIndex === colIndex"
        [ngStyle]="
          selectedParameterSetValue
            | colorMapping
              : parameter
              : element[parameter]
              : greenTableDesignValue
              : colorMappingPerParametersetValue
              : colorMappingsValue
        "
        [matTooltip]="'MAPPING.CONDITION.' + element[parameter] | translate">
        {{
          element.hasOwnProperty(parameter)
            ? ('MAPPING.CONDITION_SHORT.' + element[parameter] | translate)
            : '--'
        }}
      </td>
    }

    @case ((parameter | parameterClass) === 'index' ? parameter : '') {
      <td
        class="erp-data-cell"
        [ngClass]="
          colIndex % 2 != 0 && element.hasOwnProperty('tx')
            ? 'cell-vert-line'
            : ''
        "
        (mouseenter)="hoveredColumnIndex = colIndex"
        (mouseleave)="hoveredColumnIndex = null"
        (click)="selectedColumnIndex = colIndex"
        [class.column-hovered]="hoveredColumnIndex === colIndex"
        [class.column-selected]="selectedColumnIndex === colIndex"
        [ngStyle]="
          selectedParameterSetValue
            | colorMapping
              : parameter
              : element[parameter]
              : greenTableDesignValue
              : colorMappingPerParametersetValue
              : colorMappingsValue
        "
        [matTooltip]="
          'MAPPING.INDEX.' + parameter + '.' + element[parameter] | translate
        ">
        {{ element[parameter] }}
      </td>
    }

    @case (
      parameter === 'ff' ||
      parameter === 'ffx' ||
      parameter === 'rh' ||
      parameter === 'ne'
        ? parameter
        : ''
    ) {
      <td
        class="erp-data-cell"
        [ngClass]="
          colIndex % 2 != 0 && element.hasOwnProperty('tx')
            ? 'cell-vert-line'
            : ''
        "
        (mouseenter)="hoveredColumnIndex = colIndex"
        (mouseleave)="hoveredColumnIndex = null"
        (click)="selectedColumnIndex = colIndex"
        [class.column-hovered]="hoveredColumnIndex === colIndex"
        [class.column-selected]="selectedColumnIndex === colIndex">
        {{ element[parameter] | round }}
      </td>
    }

    @case (
      parameter === 'windpower' ||
      parameter === 'windpower_bil' ||
      parameter === 'windpower_bic' ||
      parameter === 'solarpower' ||
      parameter === 'solarpower_snl' ||
      parameter === 'solarpower_snc'
        ? parameter
        : ''
    ) {
      <td
        class="erp-data-cell"
        [ngClass]="
          colIndex % 2 != 0 && element.hasOwnProperty('tx')
            ? 'cell-vert-line'
            : ''
        "
        (mouseenter)="hoveredColumnIndex = colIndex"
        (mouseleave)="hoveredColumnIndex = null"
        (click)="selectedColumnIndex = colIndex"
        [class.column-hovered]="hoveredColumnIndex === colIndex"
        [class.column-selected]="selectedColumnIndex === colIndex">
        {{
          element.hasOwnProperty(parameter)
            ? (element[parameter] / 1000 | round)
            : '--'
        }}
      </td>
    }

    @default {
      <td
        class="erp-data-cell"
        [ngClass]="
          colIndex % 2 != 0 && element.hasOwnProperty('tx')
            ? 'cell-vert-line'
            : ''
        "
        (mouseenter)="hoveredColumnIndex = colIndex"
        (mouseleave)="hoveredColumnIndex = null"
        (click)="selectedColumnIndex = colIndex"
        [class.column-hovered]="hoveredColumnIndex === colIndex"
        [class.column-selected]="selectedColumnIndex === colIndex">
        {{ element[parameter] }}
      </td>
    }
  }
</ng-template>

<ng-template #paramLegend let-hide let-parameter="data">
  <p>
    <strong>{{ 'METPARA_EPP.' + parameter | translate }}</strong>
  </p>
  @if (parameter | hasLegend) {
    <table class="legend-table">
      @for (
        row of parameter
          | getLegend
            : selectedParameterSetValue
            : greenTableDesignValue
            : colorMappingPerParametersetValue
            : colorMappingsValue;
        track $index
      ) {
        <tr>
          <td align="center" [ngStyle]="row['style']" width="40"></td>
          @if (row.hasOwnProperty('value')) {
            <td class="legend-value">
              <span>{{ row['value'] }}</span>
            </td>
          }
          @if (row.hasOwnProperty('text')) {
            <td>
              <span>{{ 'MAPPING.' + row['text'] | translate }}</span>
            </td>
          }
          @if (row.hasOwnProperty('text2')) {
            <td>
              <span>{{ 'MAPPING.' + row['text2'] | translate }}</span>
            </td>
          }
        </tr>
      }
    </table>
  }
</ng-template>

<ng-template #erpSettings>
  <div class="custom-sidenav-panel">
    @let parameterSetsValue = parameterSets();

    <h3 class="sidenav-header-title">
      <fa-icon [icon]="['far', 'cogs']" size="lg"></fa-icon> &nbsp;
      {{ 'HOME.SETTINGS' | translate }}
    </h3>

    <div class="sidenav-layout-container">
      <h4 class="sidenav-section-title">
        {{ 'PRODUCT.EPP.SETTINGS.TABLE.CFG' | translate }}
      </h4>
      <p class="mat-body-small text-muted">
        {{ 'PRODUCT.EPP.SETTINGS.TABLE.DRAGNDROP' | translate }}
      </p>

      <mat-divider></mat-divider>

      <div class="sidenav-scroll-content">
        <mat-accordion class="sidenav-accordion">
          @for (resolution of tabsValues; track resolution) {
            <mat-expansion-panel
              [expanded]="resolution === getCurrentTabResolution()">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <fa-icon [icon]="['far', 'tasks']"></fa-icon> &nbsp;
                  @if (resolution === 1) {
                    {{ 'PRODUCT.ERP.TYPE.HOURLY' | translate }}
                  } @else {
                    {{ 'PRODUCT.ERP.TYPE.EIGHT_DAY_ALL' | translate }}
                  }
                </mat-panel-title>
              </mat-expansion-panel-header>

              @for (parameterset of parameterSetsValue; track parameterset) {
                @if (hasSettingsParameters(resolution, parameterset)) {
                  <div class="parameter-set-group">
                    <h5 class="parameter-group-header">
                      <span>
                        {{
                          'PRODUCT.EPP.PARAMETERSET.SETS.' + parameterset
                            | translate
                        }}
                        <small class="counter-badge">
                          ({{
                            getSelectedParametersCountForResolutionAndSet(
                              resolution,
                              parameterset
                            )
                          }}/{{
                            getTotalParametersCountForResolutionAndSet(
                              resolution,
                              parameterset
                            )
                          }})
                        </small>
                      </span>

                      <mat-checkbox
                        class="select-all-checkbox"
                        [checked]="isAllSelected(resolution, parameterset)"
                        [indeterminate]="
                          isSomeSelected(resolution, parameterset)
                        "
                        (change)="
                          toggleSelectAll(
                            $event.checked,
                            resolution,
                            parameterset
                          )
                        ">
                        {{ 'PRODUCT.COMMON.SELECTALL' | translate }}
                      </mat-checkbox>
                    </h5>

                    @let settingsParametersValue =
                      getSettingsParameters(resolution, parameterset);

                    <mat-selection-list
                      class="sidenav-selection-list"
                      cdkDropList
                      [cdkDropListData]="settingsParametersValue"
                      (cdkDropListDropped)="
                        onDrop($event, resolution, parameterset)
                      "
                      (selectionChange)="
                        onParameterSelectionChange(
                          $event,
                          resolution,
                          parameterset
                        )
                      ">
                      @for (entry of settingsParametersValue; track $index) {
                        <mat-list-option
                          cdkDrag
                          checkboxPosition="after"
                          class="sidenav-list-item"
                          [value]="entry.parameter"
                          [selected]="entry.selected">
                          <!-- Das harte color: black wurde hier entfernt und in die CSS-Klasse verschoben -->
                          <span matListItemIcon class="list-item-icon-wrapper">
                            @if (isMobilePlatformValue) {
                              <div cdkDragHandle class="drag-handle-zone">
                                <ng-container
                                  appWmIcon
                                  [inputParameter]="
                                    entry.parameter
                                  "></ng-container>
                              </div>
                            } @else {
                              <div class="static-icon-zone">
                                <ng-container
                                  appWmIcon
                                  [inputParameter]="
                                    entry.parameter
                                  "></ng-container>
                              </div>
                            }
                          </span>

                          <span matListItemLine class="list-item-text">
                            {{ 'METPARA_EPP.' + entry.parameter | translate }}
                          </span>
                          <mat-divider></mat-divider>
                        </mat-list-option>
                      }
                    </mat-selection-list>
                  </div>
                }
              }
            </mat-expansion-panel>
          }
        </mat-accordion>
      </div>

      <mat-divider></mat-divider>

      <div class="sidenav-footer-actions">
        <button
          mat-flat-button
          class="btn-restore"
          (click)="onRestoreStandardSettings()"
          [matTooltip]="'PRODUCT.EPP.SETTINGS.RESTORE' | translate">
          <fa-icon [icon]="['far', 'sync']"></fa-icon>
        </button>
        <button
          mat-flat-button
          color="warn"
          class="btn-cancel"
          (click)="onCancelSettings(); drawer.toggle()">
          <fa-icon [icon]="['far', 'times']"></fa-icon>
          {{ 'PRODUCT.EPP.SETTINGS.CANCEL' | translate }}
        </button>
        <button
          mat-flat-button
          color="primary"
          class="btn-save"
          (click)="onSaveSettings(); drawer.toggle()">
          <fa-icon [icon]="['far', 'check']"></fa-icon>
          {{ 'PRODUCT.EPP.SETTINGS.SAVE' | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
